// @flow
import * as React from 'react';
import { Link } from 'react-router';

type Props = {
  activeTab: string,
  insightSetId: number,
  shareWithAllIndustries: boolean
};

export default class InsightSetTabSidebar extends React.Component<Props> {
  render() {
    const { activeTab, insightSetId, shareWithAllIndustries } = this.props;
    return (
      <div className="insights-sidebar-section">
        <ul>
          <li className={activeTab === 'InsightSetDetails' ? 'active' : 'not'}>
            <Link to={`/insight-sets/${insightSetId}`}>Details</Link>
          </li>

          {insightSetId !== 'new' && (
            <span>
              <li
                className={
                  activeTab === 'InsightSetInsights' ? 'active' : 'not'
                }
              >
                <Link to={`/insight-sets/${insightSetId}/insights`}>
                  Insights
                </Link>
              </li>

              {insightSetId !== 'new' &&
                !shareWithAllIndustries && (
                  <li
                    className={
                      activeTab === 'InsightSetOrganisations' ? 'active' : 'not'
                    }
                  >
                    <Link to={`/insight-sets/${insightSetId}/organisations`}>
                      Organisations
                    </Link>
                  </li>
                )}
              {insightSetId !== 'new' &&
                !shareWithAllIndustries && (
                  <li
                    className={
                      activeTab === 'InsightSetIndustries' ? 'active' : 'not'
                    }
                  >
                    <Link to={`/insight-sets/${insightSetId}/industries`}>
                      Industries
                    </Link>
                  </li>
                )}
            </span>
          )}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/insightset/InsightSetTabSidebar.js